import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/state/app.state';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { selectAppMeta } from 'src/state/app-meta/app-meta.selectors';
import { AppMetaInformation } from '../models/application.interface';
import { Config } from '../models/config.interface';
import { loadConfig, loadConfigError } from 'src/state/config/config.actions';
import { enablePage } from 'src/state/app-meta/app-meta.actions';

@Injectable({
  providedIn: 'root'
})
export class ConfigApiService {
  private _params: Partial<AppMetaInformation> | undefined;
  private _params$ = this.store.select(selectAppMeta);
  private paramSub: Subscription;

  constructor(
    private store: Store<AppState>,
    private httpClient: HttpClient
  ) {
    //this.initConfigService();
  }

  /*  initConfigService() {
    console.log('initConf');
    this.paramSub = this._params$.subscribe((appMeta: AppMetaInformation) => {
      console.log('appMeta', appMeta);
      if (!appMeta.enableConfigAPI && appMeta.id) {
        const { user, id, project, key, lng, country, RID } = appMeta;
        this._params = { user, id, project, key, lng, country, RID };
        //this.fetchConfig();
        console.log('_params', this._params);
      }
    });
  } */

  /**
   * Fetch configuration data from the API.
   */
  fetchConfig() {
    const fetchConfigApi$ = this.apiLoadConfig();
    fetchConfigApi$.subscribe({
      next: (configData: Config) => {
        this.store.dispatch(loadConfig({ config: configData }));
        // this.paramSub.unsubscribe();
      },
      error: err => {
        console.error('HTTP Error', err.message);
        this.store.dispatch(loadConfigError({ error: err.message }));
        this.store.dispatch(
          enablePage({
            disablePage: true,
            stopLoadingSpinner: true,
            noConfigData: true
          })
        );
      }
    });
  }

  // Set the params from the store.
  // TODO: Check if this is really needed as we can always read from the store.
  // Let it right now to avoid breaking the code
  setParams(params: object) {
    this._params = params;
  }

  /**
   * Get survey configuration from the API.
   *
   * @returns an observable of the configuration data.
   */
  private apiLoadConfig(): Observable<Config> {
    return this.httpClient.get<Config>(`${environment.backendURL}${environment.endpointLoadConfig}`);
  }

  /**
   * Get the query parameters originally fetched from the URL in the subscription service
   *
   * @returns the current parameters.
   */
  public getParams(): Partial<AppMetaInformation> | undefined {
    return this._params;
  }
}

// // **************** mock data ******************
// import clientConfig from '../../config/client_config.json';
// import config from '../../config/config.json';
// import instructions from '../../config/instructions.json';
// import mediaFiles from '../../config/media.json';
// import translations from '../../config/translations.json';
// import { enablePage } from 'src/state/app-meta/app-meta.actions';
// // **************** mock data ******************
//   // **************** mock data ******************
//   _clientConfig = JSON.parse(JSON.stringify(clientConfig));
//   _config = JSON.parse(JSON.stringify(config));
//   _instructions = JSON.parse(JSON.stringify(instructions));
//   _mediaFiles = JSON.parse(JSON.stringify(mediaFiles));
//   _translations = JSON.parse(JSON.stringify(translations));
//   // **************** mock data ******************
//         // **************** mock data ******************
//         // this.store.dispatch(loadConfig({
//         //   config: {
//         //     client_config: this._clientConfig,
//         //     config: this._config,
//         //     instructions: this._instructions,
//         //     media: this._mediaFiles,
//         //     translations: this._translations
//         //   }
//         // }))
//         // **************** mock data ******************
